import { getPostsFeed } from "../server/feed.functions"
import { InfinitePostList } from "~/components/infinite-post-list"
import { usePosts } from "../hooks/use-posts"

export function PostsFeed() {
  const { data } = usePosts()

  return (
    <InfinitePostList
      initialItems={data.items}
      initialNextPage={data.nextPage}
      loadMore={(page) => getPostsFeed({ data: { page } })}
    />
  )
}
